<template>
  <div
    v-if="isLoading"
    class="d-flex justify-center align-center"
    style="height: 100vh;"
  >
    <v-progress-circular
      indeterminate
      color="#2661FF"
      size="80"
    ></v-progress-circular>
  </div>
  <div v-else>
    <v-card class="rounded-lg" flat>
      <v-card-title class="px-10 pt-10">
        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete
              :items="organizations"
              item-text="name"
              item-value="id"
              class="rounded-lg font-weight-regular"
              outlined
              :label="$t('organization.title')"
              :placeholder="$t('organization.title')"
              prepend-inner-icon="search"
              @change="getOrganization"
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="8"
            class="d-flex justify-end"
            v-if="organizationPlan.id"
          >
            <v-menu
              ref="menu"
              v-model="datePickerMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  outlined
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  class="rounded-lg font-weight-regular centered-input"
                  style="max-width: 120px !important;"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                scrollable
                @input="updateDates($event)"
                type="month"
                :max="monthLimit"
                color="#2661FF"
              ></v-date-picker>
            </v-menu>
            <v-btn
              ref="open-dialog-export"
              @click.native="toggleDialogExport(true)"
              large
              color="#2661FF"
              class="rounded-lg mt-1 ml-4"
            >
              <v-icon color="white" size="24" left>
                cloud_download
              </v-icon>
              <span class="white--text">
                {{ $t("general.export") }}
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text v-if="isLoadingStats">
        <div class="d-flex justify-center align-center">
          <v-progress-circular
            indeterminate
            color="#2661FF"
            size="80"
          ></v-progress-circular>
        </div>
      </v-card-text>
      <v-card-text
        v-else-if="!organizationPlan.id && !organization.id && !isLoadingStats"
      >
        <p class="text-center subtitle-1 grey--text text--darken-3">
          {{ $t("organization_billing.organization_report.warning_select") }}
        </p>
      </v-card-text>
      <v-card-text
        v-if="!organizationPlan.id && organization.id && !isLoadingStats"
      >
        <p class="text-center subtitle-1 grey--text text--darken-3">
          <span style="color: #2661FF">
            {{ organization.name }}
          </span>
          {{ $t("organization_billing.organization_report.no_plan") }}
        </p>
      </v-card-text>

      <v-card-text v-if="organizationPlan.id && !isLoadingStats">
        <p>
          {{ $t("organization_billing.organization_report.currency_text") }}
          <span class="text-color">{{
            `${organizationPlan.currency.name} (${organizationPlan.currency.symbol})`
          }}</span>
        </p>
        <v-row>
          <v-col
            cols="12"
            md="4"
            v-for="{ title, value, color } in headerCards"
          >
            <StatCard :title="title" :value="stats[value]" :color="color" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" v-for="{ title, value, color } in bodyCards">
            <StatCard :title="title" :value="stats[value]" :color="color" />
          </v-col>
        </v-row>
      </v-card-text>

      <DialogExport
        :module-options="['OrganizationBillingResume']"
        :filters="{ organization_id: organization.id, date }"
      />
      <DialogMessage />
    </v-card>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { organizationService } from "@/services/organization.service";
import DialogExport from "@/components/Downloads/DialogExport";
import DialogMessage from "@/components/Downloads/DialogMessage";
import StatCard from "@/components/Organization/Reports/Index/StatCard";

export default {
  name: "organizationStatsCard",
  components: {
    DialogExport,
    StatCard,
    DialogMessage
  },
  data() {
    return {
      isLoading: false,
      isLoadingStats: false,
      organizations: [],
      datePickerMenu: false,
      date: this.$moment()
        .startOf("month")
        .format("YYYY-MM"),
      monthLimit: this.$moment()
        .startOf("month")
        .format("YYYY-MM"),
      headerCards: [
        {
          title: this.$t(
            "organization_billing.organization_report.total_billing_afrus"
          ),
          value: "total_collected",
          color: "#2661FF"
        },
        {
          title: this.$t(
            "organization_billing.organization_report.month_billing"
          ),
          value: "total_month",
          color: "#2661FF"
        },
        {
          title: this.$t(
            "organization_billing.organization_report.month_billing_license"
          ),
          value: "total_month_by_license",
          color: "#2661FF"
        }
      ],
      bodyCards: [
        {
          title: this.$t(
            "organization_billing.organization_report.month_billing_fee"
          ),
          value: "total_month_by_fee",
          color: "#2661FF"
        },
        {
          title: this.$t(
            "organization_billing.organization_report.month_billing_automation"
          ),
          value: "total_month_by_automation",
          color: "#2661FF"
        },
        {
          title: this.$t(
            "organization_billing.organization_report.prev_month_billing"
          ),
          value: "total_previous_month",
          color: "#2661FF"
        },
        {
          title: this.$t(
            "organization_billing.organization_report.prev_month_billing_license"
          ),
          value: "total_previous_month_by_license",
          color: "#2661FF"
        },
        {
          title: this.$t(
            "organization_billing.organization_report.anual_billing"
          ),
          value: "total_year",
          color: "#2661FF"
        },
        {
          title: this.$t(
            "organization_billing.organization_report.anual_billing_license"
          ),
          value: "total_year_by_license",
          color: "#2661FF"
        },
        {
          title: this.$t(
            "organization_billing.organization_report.anual_billing_fee"
          ),
          value: "total_year_by_fee",
          color: "#2661FF"
        },
        {
          title: this.$t(
            "organization_billing.organization_report.anual_billing_automation"
          ),
          value: "total_year_by_automation",
          color: "#2661FF"
        }
      ],
      stats: {}
    };
  },
  async created() {
    try {
      this.isLoading = true;
      await this.getAllOrganizations();
      await this.changeOrganization({});
      await this.setOrganizationPlan({});
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  },
  watch: {
    async organization() {
      try {
        this.isLoadingStats = true;
        if (this.organization.id) {
          await this.getOrganizationPlan({
            organization_id: this.organization.id
          });
          if (this.organizationPlan.id) {
            await this.getOrganizationBilling();
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingStats = false;
      }
    }
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      organizationPlan: ({ organization: { organizationPlan } }) =>
        organizationPlan
    })
  },
  methods: {
    ...mapActions({
      getOrganization: "organization/getOrganization",
      getOrganizationPlan: "organization/getOrganizationPlan"
    }),
    ...mapMutations({
      toggleDialogExport: "downloads/toggleDialogExport",
      changeOrganization: "organization/changeOrganization",
      setOrganizationPlan: "organization/setOrganizationPlan"
    }),
    async updateDates(value) {
      this.datePickerMenu = false;
      this.date = value;
      await this.getOrganizationBilling();
    },
    async getOrganizationBilling() {
      try {
        this.isLoadingStats = true;
        const { id: organization_id } = this.organization;

        const billing_date = this.$moment(this.date)
          .startOf("month")
          .format("YYYY-MM-DD");

        const stats = (
          await axios.get(
            `admin/organizations/${organization_id}/billing-stats`,
            {
              params: {
                billing_date
              }
            }
          )
        ).data;

        Object.assign(this.stats, stats);
      } catch (error) {
        console.log(error);
        this.$noty.error(this.$t("organization_billing.errors.billing_report"));
      } finally {
        this.isLoadingStats = false;
      }
    },
    async getAllOrganizations() {
      try {
        const organizations = (await organizationService.getAllOrganizations())
          .data;
        this.organizations = organizations;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss">
.centered-input input {
  text-align: center;
  color: #222 !important;
  opacity: 80% !important;
}
</style>
